import CodeExample from "./CodeExample";
import {Leaderboard} from "../data/leaderboard";

function LeaderboardGdImplementation({leaderboard}: { leaderboard: Leaderboard }) {
    const currentUrl = window.location.hostname;
    const code = `class_name Leaderboard
extends Node

signal entries_received(was_success, entries)
signal user_entry_received(was_success, entry)
signal user_entry_sent(was_success, entry)

var server_endpoint = "${currentUrl}"
var leaderboard_id = "${leaderboard.id}"
var leaderboard_secret = "${leaderboard.secret}"

var request_entries_http_request: HTTPRequest
var request_user_entry_http_request: HTTPRequest
var send_user_value_http_request: HTTPRequest


class LeaderboardEntry:
\textends RefCounted
\tvar username: String
\tvar score: int
\tvar rank: int
\tvar meta  # : String | null

\tfunc _init(username: String, score: int, rank: int, meta) -> void:
\t\tself.username = username
\t\tself.score = score
\t\tself.rank = rank
\t\tself.meta = meta


func _ready() -> void:
\trequest_entries_http_request = HTTPRequest.new()
\tadd_child(request_entries_http_request)

\trequest_entries_http_request.request_completed.connect(_handle_received_entries)

\trequest_user_entry_http_request = HTTPRequest.new()
\tadd_child(request_user_entry_http_request)
\trequest_user_entry_http_request.request_completed.connect(_handle_received_user_entry)

\tsend_user_value_http_request = HTTPRequest.new()
\tadd_child(send_user_value_http_request)
\tsend_user_value_http_request.request_completed.connect(_handle_sent_user_value)


func request_entries(start: int, count: int) -> void:
\tvar url = server_endpoint + "/api/leaderboards/{0}/entries?start={1}&count={2}"
\turl = url.format([leaderboard_id, start, count])
\trequest_entries_http_request.request(url)


func request_user_entry(user_name: String) -> void:
\tvar url = server_endpoint + "/api/leaderboards/{0}/user/{1}"
\turl = url.format([leaderboard_id, user_name])
\trequest_user_entry_http_request.request(url)


func send_user_value(user_name: String, value: int, meta = null) -> void:
\tvar url = server_endpoint + "/api/leaderboards/{0}/user/{1}"
\turl = url.format([leaderboard_id, user_name.uri_encode()])

\tvar to_hash = user_name + str(value) + leaderboard_secret
\tvar ctx = HashingContext.new()
\tctx.start(HashingContext.HASH_SHA256)
\tctx.update(to_hash.to_utf8_buffer())
\tvar hash_result = ctx.finish()

\tvar dict_to_serialize = {"score": value, "meta": meta, "hash": hash_result.hex_encode()}

\tvar headers = PackedStringArray()
\theaders.append("Content-Type: application/json")

\tsend_user_value_http_request.request(
\t\turl, headers, HTTPClient.METHOD_PUT, JSON.stringify(dict_to_serialize)
\t)


func _handle_received_entries(
\t_result: int, response_code: int, _headers: PackedStringArray, body: PackedByteArray
) -> void:
\tvar entries: Array[LeaderboardEntry] = []
\tif response_code == 200:
\t\tvar raw_entries = JSON.parse_string(body.get_string_from_utf8()).map(
\t\t\tfunc(e): return LeaderboardEntry.new(e["username"], e["score"], e["rank"], e["meta"])
\t\t)
\t\tentries.assign(raw_entries)

\tentries_received.emit(response_code == 200, entries)


func _handle_received_user_entry(
\t_result: int, response_code: int, _headers: PackedStringArray, body: PackedByteArray
) -> void:
\tvar entry = null
\tif response_code == 200:
\t\tvar e = JSON.parse_string(body.get_string_from_utf8())
\t\tentry = (LeaderboardEntry.new(e["username"], e["score"], e["rank"], e["meta"]))
\tuser_entry_received.emit(response_code == 200, entry)


func _handle_sent_user_value(
\t_result: int, response_code: int, _headers: PackedStringArray, body: PackedByteArray
) -> void:
\tvar entry = null
\tif response_code == 200:
\t\tvar e = JSON.parse_string(body.get_string_from_utf8())
\t\tentry = (LeaderboardEntry.new(e["username"], e["score"], e["rank"], e["meta"]))
\tuser_entry_sent.emit(response_code == 200, entry)
    `

    return <div>
        <CodeExample code={code} language={"gdscript"}/>
    </div>
}

export default LeaderboardGdImplementation;